import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionGuidesArticle/pageContext';

export const PetitionGuidesErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Petition Guides Article page (error: ${error})`);
};
